"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildFulfillmentCheckout = exports.COMMAND_FULFILLMENT_STATUS_ORDER = exports.getCheckoutShippingFeeAmount = exports.resolveCheckoutFulfillmentMethod = exports.hasOfferedFulfillment = exports.offersShipping = exports.offersPickup = exports.supportsFulfillment = exports.FULFILLMENT_ENABLED_FORM_CATEGORIES = void 0;
const fulfillment_1 = require("../enums/fulfillment");
const ticketing_1 = require("../enums/ticketing");
exports.FULFILLMENT_ENABLED_FORM_CATEGORIES = [
    ticketing_1.TicketingFormCategory.Shop,
    ticketing_1.TicketingFormCategory.Auction,
];
const supportsFulfillment = (formCategory) => exports.FULFILLMENT_ENABLED_FORM_CATEGORIES.includes(formCategory);
exports.supportsFulfillment = supportsFulfillment;
const offersPickup = (methods) => methods.includes(fulfillment_1.OfferedFulfillmentMethod.Pickup);
exports.offersPickup = offersPickup;
const offersShipping = (methods) => methods.includes(fulfillment_1.OfferedFulfillmentMethod.Shipping);
exports.offersShipping = offersShipping;
const hasOfferedFulfillment = (methods) => methods.length > 0;
exports.hasOfferedFulfillment = hasOfferedFulfillment;
const resolveCheckoutFulfillmentMethod = ({ offeredMethods, selectedMethod, }) => {
    if (!(0, exports.hasOfferedFulfillment)(offeredMethods)) {
        return null;
    }
    if (offeredMethods.length === 1 && offeredMethods[0] === fulfillment_1.OfferedFulfillmentMethod.Pickup) {
        return fulfillment_1.FulfillmentMethod.Pickup;
    }
    if (selectedMethod === fulfillment_1.FulfillmentMethod.Pickup && (0, exports.offersPickup)(offeredMethods)) {
        return fulfillment_1.FulfillmentMethod.Pickup;
    }
    if (selectedMethod === fulfillment_1.FulfillmentMethod.Shipping && (0, exports.offersShipping)(offeredMethods)) {
        return fulfillment_1.FulfillmentMethod.Shipping;
    }
    if (offeredMethods.length === 1 && offeredMethods[0] === fulfillment_1.OfferedFulfillmentMethod.Shipping) {
        return fulfillment_1.FulfillmentMethod.Shipping;
    }
    return null;
};
exports.resolveCheckoutFulfillmentMethod = resolveCheckoutFulfillmentMethod;
const getCheckoutShippingFeeAmount = ({ formCategory, resolvedMethod, ticketingShippingFeeAmount, }) => (0, exports.supportsFulfillment)(formCategory) && resolvedMethod === fulfillment_1.FulfillmentMethod.Shipping ? ticketingShippingFeeAmount : 0;
exports.getCheckoutShippingFeeAmount = getCheckoutShippingFeeAmount;
exports.COMMAND_FULFILLMENT_STATUS_ORDER = [
    fulfillment_1.CommandFulfillmentStatus.NotFulfilled,
    fulfillment_1.CommandFulfillmentStatus.PartiallyReady,
    fulfillment_1.CommandFulfillmentStatus.Ready,
    fulfillment_1.CommandFulfillmentStatus.PartiallyFulfilled,
    fulfillment_1.CommandFulfillmentStatus.Fulfilled,
];
const buildFulfillmentCheckout = ({ formCategory, offeredMethods, selectedMethod, ticketingShippingFeeAmount, shippingFields = {}, }) => {
    const fulfillmentMethod = (0, exports.resolveCheckoutFulfillmentMethod)({ offeredMethods, selectedMethod });
    const shippingFeeAmount = (0, exports.getCheckoutShippingFeeAmount)({
        formCategory,
        resolvedMethod: fulfillmentMethod,
        ticketingShippingFeeAmount,
    });
    const fulfillmentCheckout = fulfillmentMethod ? { fulfillmentMethod, ...shippingFields } : null;
    return { fulfillmentMethod, shippingFeeAmount, fulfillmentCheckout };
};
exports.buildFulfillmentCheckout = buildFulfillmentCheckout;
